module.exports = __webpack_public_path__ + "static/media/19.99505c46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/19.jpg
// module id = 580
// module chunks = 0